import { render, staticRenderFns } from "./CrudWrapper.vue?vue&type=template&id=5ee2a471&"
import script from "./CrudWrapper.vue?vue&type=script&lang=js&"
export * from "./CrudWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports